let getters = {
    alert_isShow: state => state.alert.isShow,
    alert_data: state => state.alert.data,

    confirm_isShow: state => state.confirm.isShow,
    confirm_data: state => state.confirm.data,

    titleConfirm_isShow: state => state.titleConfirm.isShow,
    titleConfirm_data: state => state.titleConfirm.data,

    isShowRegisterTip: state => state.isShowRegisterTip,

    mixinTransfer_upk: state => state.mixinTransfer_upk,

    baidu_bindTokenSign: state => state.baidu_bindTokenSign
};

export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js